import { Image } from "react-native";
import { CommonActions, useNavigation } from "@react-navigation/native";
import { IconButton } from "@louise/moon-ui";
import { useProfilePictureUrl } from "../hooks/useProfilePictureUrl";
import { semanticColors } from "@louise/theme/tokens";

const avatarImage = require("../../assets/images/avatar-placeholder.png");

export default function ProfileAvatarButton() {
  const navigation = useNavigation();
  const profilePictureUrl = useProfilePictureUrl();

  return (
    <IconButton
      onPress={() => navigation.dispatch(CommonActions.navigate("Profile"))}
      accessibilityLabel="Profile"
      testID="header-profile-avatar"
      hitSlop={8}
      size={32}
      radius={16}
      style={{
        overflow: "hidden",
        borderWidth: 1,
        borderColor: semanticColors.border.glass,
      }}
    >
      <Image
        source={profilePictureUrl ? { uri: profilePictureUrl } : avatarImage}
        style={{ width: 32, height: 32 }}
        resizeMode="cover"
      />
    </IconButton>
  );
}
